<script>
  import GalerieImages from '@/components/GalerieImages.vue'
  export default {
    name: 'Dessins',
    data() {
      return {
        dessins: [],
      }
    },
    mounted() {
      this.InitialiserDonnees()
    },
    methods: {
      async InitialiserDonnees() {
        const donneesBase = await fetch(
          'https://pascalchove.com/DessinsService.php'
        )
        this.dessins = await donneesBase.json()
        this.dessins = this.dessins.sort((a, b) => b.ordre - a.ordre)
      },
    },
    computed: {
      dessinsAAfficher() {
        return this.dessins
      },
    },
    components: {
      GalerieImages,
    },
  }
</script>

<template>
  <h2>LES DESSINS</h2>

  <GalerieImages :donnees="dessinsAAfficher" categorie="dessins" />
</template>
